{
    "status": {
        "due": "Forfalden",
        "overdue": "Overskredet",
        "completed": "Afsluttet"
    },
    "blankAnswer": "Ikke udfyldt",
    "list": {
        "title": "Dagbøger",
        "emptyTitle": "Ingen dagbøger endnu",
        "emptyDescription": "Dagbøger oprettet til dig vises her",
        "checkAgain": "Tjek igen",
        "needsAttention": "Kræver din opmærksomhed",
        "needsAttentionDesc": "Dagbøger med formularer, der venter på din næste indtastning.",
        "upToDate": "Ajour",
        "ongoing": "I gang",
        "ongoingDesc": "Dagbøger der er i gang eller venter på din første indtastning.",
        "upToDateDesc": "Dagbøger i gang uden forfaldne indtastninger lige nu.",
        "noOngoing": "Ingen igangværende dagbøger i øjeblikket",
        "completed": "Afsluttet",
        "completedDesc": "Dagbøger der er afsluttet (indsamler ikke længere indtastninger).",
        "noCompleted": "Ingen afsluttede dagbøger endnu",
        "openDiary": "Åbn dagbog",
        "reviewDiary": "Gennemse dagbog"
    },
    "goToDiaries": {
        "title": "Gå til {{diaryWord}}",
        "actionRequiredCount": "Handling påkrævet ({{count}})",
        "actionRequiredOneForm": "Handling påkrævet ({{count}} formular)",
        "actionRequiredManyForms": "Handling påkrævet ({{count}} formularer)",
        "defaultDescription": "Dagbøger er dine personlige sundhedslogbøger og hjælper med at forbedre behandling og forskning.",
        "oneFormDue": "Du har {{count}} formular, der skal udfyldes.",
        "manyFormsDue": "Du har {{count}} formularer, der skal udfyldes.",
        "diariesNeedAttention": "Du har {{count}} {{diaryWord}} med formularer, der kræver din opmærksomhed."
    }
}
